/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "b8a8489de1256cb08b8d02882e2122081b82a1e5";
